
export default {
  layout: "default",
  async asyncData({ $axios, params, error, redirect }) {
    const pageData = await $axios.get(`/uk-api/uk/goods/detail?product_code=${params.code}`);
    let indexGoodsRankLists=[]
    if(pageData.result?.category_id){
        try{
          indexGoodsRankLists = await $axios.get(`/uk-api/uk/goods/recommend/${pageData.result?.category_id}`);
        }catch (err) {
          console.log(err);
        }
      }else{
        indexGoodsRankLists = await $axios.get("/uk-api/home/indexGoodsRankList");
    }
    return {
      pageData: pageData.result,
      indexGoodsRankLists: indexGoodsRankLists.result,
    };
  },
  // middleware: 'auth',
  data() {
    return {
      pageData:null,
      indexGoodsRankLists:[]
    };
  },
  head() {
    return {
      title: this.pageData?.product_name || 'PromoCollection',
      meta: [
        { name: 'keywords', content: this.pageData?.keywords },
        { name: 'description', content: this.pageData?.main?.description },
      ],
    };
  },
};
